/**
 * The one place that reads `import.meta.env`. Everything else imports `env`.
 *
 * Defaults mirror the container: same-origin `/api` (nginx proxies it to the
 * api Service) and `<origin>/auth/callback` as the EMS redirect target, which
 * is exactly what `EMS_CALLBACK_URL` is set to on the api side
 * (DEPLOYMENT.md → `https://warehouse.gigachop.se/auth/callback`).
 */

function trimTrailingSlash(value: string): string {
  return value.replace(/\/+$/, '');
}

const origin = typeof window === 'undefined' ? 'http://localhost:5173' : window.location.origin;

const emsBaseUrl = trimTrailingSlash(import.meta.env.VITE_EMS_BASE_URL?.trim() ?? '');

export const env = {
  /** No trailing slash. `/api` by default. */
  apiBaseUrl: trimTrailingSlash(import.meta.env.VITE_API_BASE_URL?.trim() || '/api'),
  ems: {
    /** Empty string ⇒ SSO is not configured in this build. */
    baseUrl: emsBaseUrl,
    systemCode: import.meta.env.VITE_EMS_SYSTEM_CODE?.trim() || 'WMS',
    callbackUrl: import.meta.env.VITE_EMS_CALLBACK_URL?.trim() || `${origin}/auth/callback`,
    /** `false` ⇒ the login page falls back to the dev-login form. */
    configured: emsBaseUrl.length > 0,
  },
  publicUrl: trimTrailingSlash(import.meta.env.VITE_PUBLIC_URL?.trim() || origin),
  isDev: import.meta.env.DEV,
} as const;

export type Env = typeof env;
